import React from "react";
import {Box, Theme} from "@mui/material";
import C036SearchField from "../../../../content/C036SearchField/C036SearchField";
import routes from "../../../../../common/constants/routes";

interface MobileMenuSearchProps {
    searchEnabled: boolean;
    pathname: string | null;
    onClose: () => void;
}

const MobileMenuSearch: React.FC<MobileMenuSearchProps> = ({
                                                               searchEnabled,
                                                               pathname,
                                                               onClose
                                                           }) => {
    if (!searchEnabled || (pathname && pathname.indexOf(routes.SEARCH_RESULTS) > -1)) {
        return null;
    }

    return (
        <Box sx={{
            backgroundColor: (theme: Theme) => theme.palette.grey[100],
            margin: '-16px -24px 0',
            padding: '16px 36px'
        }}>
            <C036SearchField
                fullWidth={true}
                isInContent={false}
                onSearchSubmit={onClose}
                dataCypress="offCanvasMenuSearch"
                customInputProps={{
                    style: {border: '1px solid var(--border-color)', borderRadius: '4px'}
                }}
            />
        </Box>
    );
};

export default MobileMenuSearch;
